package com.milta.feature.admin.presentation

import com.milta.feature.admin.domain.entity.AdminOcrAnalysis

/** State for the Admin "Usage IA" screen — read-only. */
data class AdminOcrAnalysisState(
    val isLoading: Boolean = true,
    val analysis: AdminOcrAnalysis? = null,
    /** "server_error" | "offline". */
    val error: String? = null,
)
